import React, {Component} from 'react';
import styles from './css/Admin.module.css';
import TopBar from './components/TopBar';
import LeftMenu from './components/LeftMenu';
import ResultsView from './components/ResultsView';
import BottomBar from './components/BottomBar';
import DialogBoxAddUser from './components/DialogBoxAddUser';
import DialogBoxAddUserConfirmation from './components/DialogBoxAddUserConfirmation';
import DialogBoxEditUser from './components/DialogBoxEditUser';
import DialogBoxEditUserActivate from './components/DialogBoxEditUserActivate';
import DialogBoxEditUserDeactivate from './components/DialogBoxEditUserDeactivate';
import DialogBoxEditUserPasswordReset from './components/DialogBoxEditUserPasswordReset';
import DialogBoxVacantSubstitution from './components/DialogBoxVacantSubstitution';
import Popup from '../../globalcomponents/Popup';
import AdminExerciseTemplate from '../../components/AdminExerciseTemplate'
import TargetingChangeWidth from '../Targeting/Search/Search'
import AuditTrail from './components/AuditTrail';
import Axios from '../../components/Axios';

class Admin extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ViewValue: 0,
            popup: false,
            Views: [],
            activeView: 0,
            ResultsPerPage: 20,
            CurrentPage: 0,
            data: {},
            orgData: {},
            confirmationData: {},
            recordIndex: -1,
            userId: -1,
            wizard: false,
            substitutionDialog: null,   // { data, onSaved } | null
            substitutionDeletePending: null  // { data, onSaved } | null
        }
    }

    changeAdminView(i, data, num, id, wizard) {
        if (i === -1) {
            this.setState({
                ViewValue: 0,
                popup: false,
                wizard: wizard
            });
        }
        else {
            if (data !== undefined) {
                this.setState({
                    ViewValue: i,
                    popup: true,
                    confirmationData: data,
                    wizard: wizard
                });
            }
            if (num >= 0) {
                this.setState({
                    ViewValue: i,
                    popup: true,
                    recordIndex: num,
                    wizard: wizard
                });
            }
            if (id > 0) {
                this.setState({
                    ViewValue: i,
                    popup: true,
                    userId: id,
                    wizard: wizard
                });
            }
            else {
                this.setState({
                    ViewValue: i,
                    popup: true,
                    wizard: wizard
                });
            }
        }
    }

    setPageViewCount(ResultsPerPage, CurrentPage) {
        this.setState({
            ResultsPerPage: ResultsPerPage,
            CurrentPage: CurrentPage
        })
        this.buildResults(this.state.data, ResultsPerPage, CurrentPage)
    }

    setPage(CurrentPage) {
        this.setState({CurrentPage: CurrentPage})
        this.buildResults(this.state.data, this.state.ResultsPerPage, CurrentPage)
    }

    setData(d) {
        this.setState({
            data: d,
            CurrentPage: 0
        });
        this.buildResults(d, this.state.ResultsPerPage, this.state.CurrentPage)
    }

    setOrgData(d) {
        this.setState({
            orgData: d,
        });
    }

    componentDidMount() {
        this.buildResults(this.state.data, this.state.ResultsPerPage, this.state.CurrentPage)
    }

    buildResults(data, ResultsPerPage, CurrentPage) {
        let results = [
            <div key={0} className={styles.results}>
                <ResultsView changeAdminView={this.changeAdminView.bind(this)} setData={this.setData.bind(this)} data={data} ResultsPerPage={ResultsPerPage}
                CurrentPage={CurrentPage} />
            </div>,
            <div key={1} className={styles.bottomBar}>
                <BottomBar data={data} setPageViewCount={this.setPageViewCount.bind(this)} setPage={this.setPage.bind(this)} CurrentPage={this.state.CurrentPage}/>
            </div>
        ]
        this.setState({Views: [results]})
    }

    changeView(i) {
        this.setState({activeView: i});
    }

    close() {
        this.setState({
            popup: false
        });
    }

    openEditDialog(data, onSaved) {
        this.setState({ substitutionDialog: { data, onSaved }, substitutionDeletePending: null });
    }

    openDeleteDialog(data, onSaved) {
        this.setState({ substitutionDeletePending: { data, onSaved }, substitutionDialog: null });
    }

    closeSubstitutionDialog() {
        this.setState({ substitutionDialog: null, substitutionDeletePending: null });
    }

    confirmDelete() {
        const { substitutionDeletePending } = this.state;
        if (!substitutionDeletePending) return;
        Axios('/api/v1/admin/delete-vacant-substitution', { VACANT_TERR_ID: substitutionDeletePending.data.VACANT_TERR_ID }, () => {
            substitutionDeletePending.onSaved();
            this.closeSubstitutionDialog();
        });
    }

    render() {
        let DialogBoxes = [<DialogBoxAddUser user={this.props.user} setData={this.setData.bind(this)} changeAdminView={this.changeAdminView.bind(this)}/>,
            <DialogBoxAddUserConfirmation user={this.props.user} changeAdminView={this.changeAdminView.bind(this)} confirmationData={this.state.confirmationData}/>,
            <DialogBoxEditUser user={this.props.user} changeAdminView={this.changeAdminView.bind(this)} setData={this.setData.bind(this)} data={this.state.data} recordIndex={this.state.recordIndex} userId={this.state.userId}/>,
            <DialogBoxEditUserActivate wizard={this.state.wizard} user={this.props.user} changeAdminView={this.changeAdminView.bind(this)} setData={this.setData.bind(this)} data={this.state.data} recordIndex={this.state.recordIndex} userId={this.state.userId}/>,
            <DialogBoxEditUserDeactivate wizard={this.state.wizard} user={this.props.user} changeAdminView={this.changeAdminView.bind(this)} setData={this.setData.bind(this)} data={this.state.data} recordIndex={this.state.recordIndex} userId={this.state.userId}/>,
            <DialogBoxEditUserPasswordReset user={this.props.user} changeAdminView={this.changeAdminView.bind(this)} setData={this.setData.bind(this)} data={this.state.data} recordIndex={this.state.recordIndex} userId={this.state.userId}/>
        ]

        let results = [
            <ResultsView key={0} changeAdminView={this.changeAdminView.bind(this)} setData={this.setData.bind(this)} data={this.state.data} ResultsPerPage={this.state.ResultsPerPage}
            CurrentPage={this.state.CurrentPage} orgData={this.state.orgData} setOrgData={this.setOrgData.bind(this)}
            openEditDialog={this.openEditDialog.bind(this)}
            openDeleteDialog={this.openDeleteDialog.bind(this)} />,
            <div key={1} className={styles.bottomBar}>
                <BottomBar data={this.state.data} setPageViewCount={this.setPageViewCount.bind(this)} setPage={this.setPage.bind(this)} CurrentPage={this.state.CurrentPage}/>
            </div>
        ]

        let view = [
            results,
            <AdminExerciseTemplate key='HCPTARGETING' user={this.props.user} title={"Targeting Exercises"} ChangeWidth={TargetingChangeWidth} EXERCISE_ID_KEY={'TARGETING_EXERCISE_ID'} moreButtons={true} type="HCP" endpoints={{
                getCustomColumns: '/api/v1/admin/targetingexercise/get-custom-columns',
                addExercise: '/api/v1/admin/targetingexercise/add-exercise',
                getExercise: '/api/v1/admin/targetingexercise/get-exercise',
                getExercises: '/api/v1/admin/targetingexercise/get-exercises',
                deleteExercise: '/api/v1/admin/targetingexercise/delete-exercise',
                editExercise: '/api/v1/admin/targetingexercise/edit-exercise',
                editExerciseWidth:'/api/v2/targetingexercise/edit-exercise-column-order',
                setReasons: '/api/v1/admin/targetingexercise/set-reasons',
                getReasons: '/api/v1/admin/targetingexercise/get-reasons',
                editPerTargetLimits: '/api/v1/admin/targetingexercise/edit-per-target-limits'

            }} />,
            <AuditTrail key='AUDIT_TRAIL' changeAdminView={this.changeAdminView.bind(this)} />
        ]
        return (
            <div>
                {this.state.popup ? (<Popup component={<div className={styles.editScreen}>{DialogBoxes[this.state.ViewValue]}</div>} />) : ""}
                {this.state.substitutionDialog && (
                    <Popup component={
                        <div className={styles.editScreen}>
                            <DialogBoxVacantSubstitution
                                data={this.state.substitutionDialog.data}
                                onClose={this.closeSubstitutionDialog.bind(this)}
                                onSaved={this.state.substitutionDialog.onSaved}
                            />
                        </div>
                    } />
                )}
                {this.state.substitutionDeletePending && (
                    <Popup component={
                        <div className={styles.editScreen}>
                            <div className={styles.confirmDialog}>
                                <div className={styles.confirmTitle}>Clear Override</div>
                                <div className={styles.confirmBody}>
                                    Remove the manual substitution for <strong>{this.state.substitutionDeletePending.data.VACANT_TERR_NAME}</strong>? The territory will revert to its automatic pairing.
                                </div>
                                <div className={styles.confirmButtons}>
                                    <div className={styles.cancelBtn} onClick={this.closeSubstitutionDialog.bind(this)}>CANCEL</div>
                                    <div className={styles.deleteBtn} onClick={this.confirmDelete.bind(this)}>CLEAR</div>
                                </div>
                            </div>
                        </div>
                    } />
                )}
                <div className={styles.Admin}>
                    <div className={styles.topBar}>
                        <TopBar />
                    </div>
                    <div className={styles.mainView}>
                        <div className={styles.menu}>
                            <LeftMenu changeView={this.changeView.bind(this)} active={this.state.activeView}/>
                        </div>
                        <div key={0} className={styles.results}>
                            {view[this.state.activeView]}
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default Admin;
